<template>
  <div class="main-panel">
    <!-- Top bar -->
    <div class="nav-bar-operations">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        class="logo-button"
        @click="backMainPanel"
      />
    </div>

    <!-- Header / Welcome -->
    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">A</div>
        <div class="greet">
          <h1>Bienvenido/a a <span>Almacén</span></h1>
          <p class="sub">Selecciona una opción para continuar</p>
        </div>
      </div>
      <button class="btn btn--back" @click="backMaintenance">Volver a Mantenimiento</button>
    </header>

    <!-- Content Grid -->
    <section class="grid">
      <article
        v-for="tile in visibleTiles"
        :key="tile.key"
        class="card"
        role="link"
        tabindex="0"
        @click="go(tile.to)"
        @keyup.enter="go(tile.to)"
      >
        <div class="card__media">
          <img :src="tile.img" :alt="tile.title" />
        </div>
        <div class="card__content">
          <div class="card__title">
            <h2>{{ tile.title }}</h2>
            <span class="chip" v-if="tile.chip">{{ tile.chip }}</span>
          </div>
          <ul class="card__list">
            <li v-for="(p, i) in tile.points" :key="i">{{ p }}</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" :to="tile.to">Entrar</router-link>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'WarehouseModule',
  data() {
    return {
      permissions: [],
      tiles: [
        {
          key: 'warehouse-parts',
          title: 'Inventario de piezas',
          img: require('@/assets/tools-card.jpg'),
          points: ['Altas, bajas y edición de piezas', 'Códigos de barras únicos'],
          to: { path: '/warehouse/parts' },
          chip: 'Core',
          requiredPerms: ['maintenance.view_warehouse', 'maintenance.manage_parts'],
        },
        {
          key: 'warehouse-entry-vouchers',
          title: 'Vales de entrada',
          img: require('@/assets/report-card.jpg'),
          points: ['Registro de compras', 'Suman al stock'],
          to: { path: '/warehouse/entry-vouchers' },
          requiredPerms: ['maintenance.view_warehouse', 'maintenance.create_entry_voucher'],
        },
        {
          key: 'warehouse-exit-vouchers',
          title: 'Vales de salida',
          img: require('@/assets/operations-card.jpg'),
          points: ['Retiros autorizados', 'Restan del stock', 'Vinculables a órdenes de taller'],
          to: { path: '/warehouse/exit-vouchers' },
          requiredPerms: ['maintenance.view_warehouse', 'maintenance.create_exit_voucher'],
        },
        {
          key: 'warehouse-purchase-orders',
          title: 'Órdenes de compra',
          img: require('@/assets/report-card.jpg'),
          points: ['Pedido al proveedor', 'Compras da seguimiento', 'El almacén recibe contra la orden'],
          to: { path: '/warehouse/purchase-orders' },
          requiredPerms: [
            'maintenance.view_warehouse',
            'maintenance.view_purchase_order',
            'maintenance.create_purchase_order',
            'maintenance.update_purchase_order',
          ],
        },
        {
          key: 'warehouse-tool-loans',
          title: 'Préstamo de herramienta',
          img: require('@/assets/tools-card.jpg'),
          points: ['Entrega al mecánico', 'Hora de salida y de devolución', 'La existencia vuelve al regresar'],
          to: { path: '/warehouse/tool-loans' },
          requiredPerms: [
            'maintenance.view_warehouse',
            'maintenance.view_tool_loan',
            'maintenance.create_tool_loan',
          ],
        },
        {
          key: 'warehouse-requisitions',
          title: 'Requisiciones',
          img: require('@/assets/report-card.jpg'),
          points: ['Solicitudes del taller', 'Código de barras', 'Surtido parcial o completo'],
          to: { path: '/warehouse/requisitions' },
          requiredPerms: [
            'maintenance.view_warehouse',
            'maintenance.view_requisition',
            'maintenance.create_requisition',
            'maintenance.create_exit_voucher',
          ],
        },
      ],
    }
  },
  computed: {
    visibleTiles() {
      return this.tiles.filter((tile) => this.hasPerm(tile.requiredPerm || tile.requiredPerms))
    },
  },
  created() {
    this.fetchCurrentUser()
  },
  methods: {
    hasPerm(permOrPerms) {
      if (!permOrPerms) return false
      const perms = Array.isArray(permOrPerms) ? permOrPerms : [permOrPerms]
      return perms.some((perm) => {
        if (this.permissions.includes(perm)) return true
        return this.permissions.includes(`access_control.${perm}`)
      })
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        const warehousePerms = [
          'maintenance.view_warehouse',
          'maintenance.manage_parts',
          'maintenance.create_entry_voucher',
          'maintenance.create_exit_voucher',
          'maintenance.link_voucher_to_order',
          'maintenance.view_requisition',
          'maintenance.create_requisition',
        ]
        if (!this.hasPerm(warehousePerms)) {
          this.$router.push({ name: 'MainPanel' })
        }
      } catch (error) {
        this.$router.push({ name: 'MainPanel' })
      }
    },
    backMainPanel() {
      this.$router.push({ path: '/main-panel' })
    },
    backMaintenance() {
      this.$router.push({ path: '/modulo-mantenimiento' })
    },
    go(to) {
      this.$router.push(to)
    },
  },
}
</script>

<style scoped>
.main-panel {
  --bg: #ffffff;
  --panel: #151924;
  --muted: #373838;
  --text: #000000;
  --brand: #ffc434;
  --brand-ink: #3a2a00;
  --primary: #2563eb;
  --danger: #ef4444;
  --ring: rgba(37, 99, 235, 0.35);
}
@media (prefers-color-scheme: light) {
  .main-panel {
    --bg: #f7f8fb;
    --panel: #ffffff;
    --muted: #667085;
    --text: #0f172a;
    --brand: #ffc434;
    --brand-ink: #3a2a00;
    --primary: #2563eb;
    --danger: #dc2626;
    --ring: rgba(37, 99, 235, 0.25);
  }
}

.main-panel {
  min-height: 100vh;
  background: var(--bg);
  padding: 12vh 24px 48px;
}

.nav-bar-operations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: var(--brand);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding-left: 16px;
  box-shadow: 0 2px 0 rgba(0,0,0,.05);
}
.logo-button { height: 55%; object-fit: contain; cursor: pointer; }

.header {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.header__left { display: flex; align-items: center; gap: 14px; }
.avatar {
  width: 44px; height: 44px; border-radius: 10px; display: grid; place-items: center;
  background: linear-gradient(135deg, var(--brand), #ffe188);
  color: var(--brand-ink); font-weight: 800;
  box-shadow: 0 6px 18px rgba(0,0,0,.15);
}
.greet h1 { font-size: 1.15rem; color: var(--text); margin: 0; }
.greet h1 span { font-weight: 700; }
.greet .sub { margin: 2px 0 0; color: var(--muted); font-size: .9rem; }

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
  margin-top: 10px;
}
.card {
  background: #fff;
  border: 1px solid rgba(0,0,0,.08);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,.08);
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
  outline: none;
  cursor: pointer;
}
.card:focus { box-shadow: 0 0 0 6px var(--ring); }
.card:hover { transform: translateY(-3px); border-color: rgba(0,0,0,.12); }

.card__media { position: relative; height: 140px; overflow: hidden; }
.card__media img { width: 100%; height: 100%; object-fit: cover; display: block; }

.card__content { padding: 14px; display: grid; gap: 10px; }
.card__title { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.card__title h2 { font-size: 1rem; margin: 0; color: #000; }
.chip { font-size: .7rem; background: rgba(37,99,235,.15); color: #2563eb; padding: 4px 8px; border-radius: 999px; border: 1px solid rgba(37,99,235,.35); }

.card__list { margin: 0; padding-left: 16px; color: #444; }
.card__list li { margin: 3px 0; }

.card__actions { display: flex; justify-content: flex-end; }

.btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 14px; border-radius: 12px; border: 1px solid transparent;
  background: var(--panel); color: var(--text); cursor: pointer; text-decoration: none;
  transition: transform .15s ease, box-shadow .2s ease, background .2s ease, color .2s ease;
}
.btn:focus { outline: none; box-shadow: 0 0 0 6px var(--ring); }

.btn--primary { background: var(--primary); color: white; }
.btn--primary:hover { transform: translateY(-1px); box-shadow: 0 8px 22px rgba(37,99,235,.35); }

.btn--back { background: var(--panel); color: #fff; font-size: .8rem; }
.btn--back:hover { background: #000; }

@media (max-width: 720px) {
  .header { flex-direction: column; align-items: stretch; gap: 12px; }
}

@media screen and (max-height: 586px) {
  .nav-bar-operations { height: 10vh; }
  .main-panel { padding-top: 12vh; }
}
@media screen and (min-height: 930px) {
  .main-panel { padding-top: 14vh; }
}
</style>
